module.exports = __webpack_public_path__ + "static/media/pending-indicator.78b4c994.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pending-indicator.svg
// module id = ./src/assets/images/pending-indicator.svg
// module chunks = 0